const liveTvData = [
    { 
        id: 1,
        name: "Sony Ten 2",
        img: "https://i.ibb.co/PMLBHrd/sony-ten.png",
        type: "sports",
        video: "https://www.youtube.com/embed/OGAg_8fmEd0"
    },
    { 
        id: 2,
        name: "Sony Six",
        img: "https://i.ibb.co/X481yMT/sony-six.png",
        type: "sports",
        video: "https://www.youtube.com/embed/UrdibRo4zw0"
    },
    { 
        id: 3,
        name: "Somoy Tv",
        img: "https://i.ibb.co/dm7CdKF/shomoy.png",
        type: "news",
        video: "https://www.youtube.com/embed/P9ktaaRF6X4"
        
    },
    { 
        id: 4,
        name: "RTV",
        img: "https://i.ibb.co/wwpJJ5n/rtv.png",
        type: "entertainment",
        video: "https://www.youtube.com/embed/ZU0nbDmYElo"
    },
    { 
        id: 5,
        name: "NTV",
        img: "https://i.ibb.co/JR9K4Gh/ntv.png",
        type: "entertainment",
        video: "https://www.youtube.com/embed/CTgy4ctnYh4"
    },
    { 
        id: 6,
        name: "Nick",
        img: "https://i.ibb.co/BLZsFmY/nick.png",
        type: "kids",
        video: "https://www.youtube.com/embed/R1AN-a8TUqA"
    },
    { 
        id: 7,
        name: "News 24",
        img: "https://i.ibb.co/19z5TTF/news24.png",
        type: "news",
        video: "https://www.youtube.com/embed/44-JZSKXCw8"
    },
    { 
        id: 8,
        name: "MTV Music",
        img: "https://i.ibb.co/2vH2Y5C/mtv.png",
        type: "music",
        video: "https://www.youtube.com/embed/Ui0tLx1Fcn4"
    },
    { 
        id: 9,
        name: "Independent",
        img: "https://i.ibb.co/MpVgqYB/independent.png",
        type: "entertainment",
        video: "https://www.youtube.com/embed/yuT26TfMvQ0"
    },
    { 
        id: 10,
        name: "DBC News",
        img: "https://i.ibb.co/YZNsH5K/dbc.png",
        type: "news",
        video: "https://www.youtube.com/embed/oRe7FSr15vQ"
    },
    { 
        id: 11,
        name: "Bongo Movies",
        img: "https://i.ibb.co/7g7j38v/bongo.png",
        type: "movies",
        video: "https://www.youtube.com/embed/Az2zZ-4RyOc"
    },
    { 
        id: 12,
        name: "Bangla Vision",
        img: "https://i.ibb.co/SNWYyxH/bangla-vision.png",
        type: "entertainment",
        video: "https://www.youtube.com/embed/mEJLBXdKEA8"
    },
    { 
        id: 13,
        name: "ATN Bangla",
        img: "https://i.ibb.co/mHhV0nw/atn-bangla.png",
        type: "entertainment",
        video: "https://www.youtube.com/embed/MGqeccDMZvg"
    },
    { 
        id: 14,
        name: "Aljajeera",
        img: "https://i.ibb.co/1rKL1Rj/aljajeera.png",
        type: "news",
        video: "https://www.youtube.com/embed/23he_ZGo-ic"
    },

];

export default liveTvData;